import React, { useEffect, useState } from 'react'
import LayoutMain from '../layout/LayoutMain'
import '../style/hump-club-landing.css'
import HumpClubLandingOffersGrid from '../components/HumpClubLandingOffersGrid/HumpClubLandingOffersGrid'
import HumpClubLandingHero from '../components/HumpClubLandingHero/HumpClubLandingHero'
import HumpClubLandingFooter from '../components/HumpClubLandingFooter/HumpClubLandingFooter'

export const useWindowSize = () => {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768)
    }

    checkMobile()
    window.addEventListener('resize', checkMobile)
    return () => window.removeEventListener('resize', checkMobile)
  }, [])

  return isMobile
}

const offers = [
  {
    text: 'WEEKLY\nDISCOUNTS',
    image: '/static/images/hump-club-landing/weekly_discounts.jpg',
    textPosition: 'bottom',
  },
  {
    text: 'BONUS\nDRINKS\n& PRIZES',
    image: '/static/images/hump-club-landing/bonus_drinks_prizes.jpg',
    textPosition: 'top',
  },
  {
    text: 'B-DAY\nGIFTS',
    image: '/static/images/hump-club-landing/bday_gifts.jpg',
    textPosition: 'bottom',
  },
  {
    text: 'EXCLUSIVE\nGAMES',
    image: '/static/images/hump-club-landing/exclusive_games.jpg',
    textPosition: 'top',
  },
  {
    text: 'PERSONALISED\nOFFERS',
    image: '/static/images/hump-club-landing/personalised_offers.jpg',
    textPosition: 'bottom',
  },
  {
    text: 'HUMP CLUB\nANNIVERSARY\nGIFT',
    image: '/static/images/hump-club-landing/anniversary_gift.jpg',
    textPosition: 'top',
  },
]

export default function HumpClub() {
  return (
    <LayoutMain noContainer>
      <HumpClubLandingHero />
      <HumpClubLandingOffersGrid offers={offers} />
      <HumpClubLandingFooter />
    </LayoutMain>
  )
}
